<template>
  <Modal
    content-class="column no-wrap overflow-hidden"
    full-height
    :modal-style="{ maxWidth: '900px' }"
    offset-menu
    :title="title"
  >
    <LoadingBar
      v-if="loading"
      height="2"
    />
    <div class="q-pa-md">
      <div
        v-if="original_title"
        class="q-pb-smd"
      >
        ({{ original_title }})
      </div>
      <div>
        {{
          formatIntlDate(mention.timestamp, {
            day: "numeric",
            month: "short",
            hour: "numeric",
            minute: "numeric",
          })
        }}
        ·
        <strong>
          {{ mention.source.name }}
        </strong>
        <span v-if="mention.author">
          · {{ capitalizeName(mention.author) }}
        </span>
        ·
        {{
          $t("modals.see_full_text_modal.word_count", {
            wordCount: mention.word_count,
          })
        }}
      </div>
    </div>
    <div class="q-pa-xl full-text flex-1 overflow-auto text-justify">
      <!-- eslint-disable vue/no-v-html -->
      <div v-html="nl2br(body)" />
    </div>
  </Modal>
</template>

<script>
import { LoadingBar } from "shared/components/base";
import Modal from "shared/components/core/modals/Modal.vue";
import { formatIntlDate } from "shared/helpers/date";
import { capitalizeName, nl2br } from "shared/helpers/string";

export default {
  name: "SeeFullTextModal",
  components: {
    Modal,
    LoadingBar,
  },
  props: {
    mention: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      body: "",
      title: "",
      original_title: "",
    };
  },
  async mounted() {
    if (!this.body) {
      const article = (
        await this.$streemApiV1.get(`articles/${this.mention.id}`)
      ).data;

      this.body = article.translated_body || article.full_body || article.body;
      this.title = article.title;

      if (article.translated_title) {
        this.title = article.translated_title;
        this.original_title = article.title;
      }

      this.loading = false;
    }
  },
  methods: {
    capitalizeName,
    nl2br,
    formatIntlDate,
  },
};
</script>

<style lang="scss" scoped>
.full-text {
  border-top: 1px solid var(--s-color-denim-2);
}
</style>
